import imageSegmentationApi from '@frontend/services/api/image-segmentation';
import { imageSegmentationEventBroker, IMAGE_SEGMENTATION_EVENTS } from './event-broker';

export async function startSegmentationPreview({ customerId, imagePath, layoutId, layoutName, beforeShow }) {
  const { data } = await imageSegmentationApi.startSegmentation(
    customerId, imagePath, layoutId, layoutName
  );

  if (data.success === false || !data.job_uuid) {
    throw new Error(data.message || 'Failed to start image segmentation');
  }

  if (beforeShow) await beforeShow();

  if (data.cached && data.layer_data) {
    imageSegmentationEventBroker.fire(IMAGE_SEGMENTATION_EVENTS.SHOW_CACHED_PREVIEW, {
      jobUuid: data.job_uuid,
      customerId,
      imagePath,
      layoutId,
      layoutName,
      originalImagePath: data.original_image_path,
      stale: data.stale === true,
      displayedWidth: data.displayed_width,
      displayedHeight: data.displayed_height,
      cachedData: {
        layers: data.layer_data,
        inpaintedBackgroundUrl: data.inpainted_background_path || '',
      },
    });
  } else {
    imageSegmentationEventBroker.fire(IMAGE_SEGMENTATION_EVENTS.SHOW_PREVIEW, {
      jobUuid: data.job_uuid,
      customerId,
      originalImageUrl: imagePath,
      layoutId,
      layoutName,
    });
  }
}
